<template>
  <div class="backimg">
    <div class="search-content" style="width:1256px;margin: 0 auto;">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item index="300"><strong>待加工</strong><span class="badge" v-if="statusnumber300>0">{{statusnumber300}}</span></el-menu-item>
        <el-menu-item index="alreadymachining">已加工</el-menu-item>
        <el-menu-item index="all">全部</el-menu-item>
      </el-menu>
      <div class="line"></div>
    </div>
    <el-main>
      <comment :is="currentcomponent" :roletype="'machining'" :mystatus="status" v-if="visible"  @bindTip="bindTip"></comment>
    </el-main>

  </div>

</template>

<script>
  import CstagreementList from './CstagreementList';
  import {countlist} from '@/api/set/csagreement';

  export default {
    data() {
      return {
        activeIndex: '300',
        currentcomponent: 'CstagreementList',
        visible: true,
        status: '300',
        statuseslist: "300;",
        statusnumber300:0,
      };
    },
    methods: {
      handleSelect(key, keyPath) {
        this.status = key
        this.visible = false
        this.$nextTick(() => {
          this.visible = true
        })

      },
      bindTip(){
        this.statusnumber300=0
        countlist({statuseslist: this.statuseslist}).then(response => {
          response.data.obj.forEach(item=>{
            if(item.status==300){
              this.statusnumber300=item.number
            }
          })
        })
      }

    },
    mounted() {
      this.bindTip()
    },
    components: {
      CstagreementList
    }

  }


</script>
<style scoped>
  .el-main {
    padding: 0px;
    /*height: calc(100vh - 97px);*/
    width:1256px;
    margin:0 auto;
    background-color: white;
    overflow: auto;
  }

  .el-menu-item {
    height: 48px !important;
    line-height: 48px !important;
  }



</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/Machining.vue